export default __webpack_public_path__ + "static/media/3-2-1.f5e74c46.jpg";